import { AxiosResponse } from 'axios';
import AppConstants from '../constants/AppConstants';
import { PredefinedShiftCommentResPage, PredefinedShiftCommentRes, PredefinedShiftCommentReq } from '../proxy/proxy';
import { AxiosPredefinedShiftCommentClient } from '../proxy/ProxyClients';

const PredefinedShiftCommentService = {
  getAllComments: () => AxiosPredefinedShiftCommentClient.page({
    pageNumber: 1,
    pageSize: AppConstants.MAX_PAGE_SIZE
  }).then((resp: PredefinedShiftCommentResPage) => {
    const result: Array<PredefinedShiftCommentRes> = resp?.items || [];
    return result.filter((comment: any) => !comment.isSoftDeleted);
  }),
  getCommentById: (id: number) => AxiosPredefinedShiftCommentClient.get(id).then((resp) => resp),
  createComment: (data: PredefinedShiftCommentReq) => AxiosPredefinedShiftCommentClient.create(data),
  updateComment: (id: number, data: PredefinedShiftCommentReq) => AxiosPredefinedShiftCommentClient.update(id, data),
  deleteComment: (id: number = 0) => AxiosPredefinedShiftCommentClient.delete(id)
};

export default PredefinedShiftCommentService;
